class BankCell extends UITableViewCell
{
    private titleLabel:MUILabel = null;
    private totalLabel:MUILabel = null;
    private statusView:MUIView = null;
    private uncategorizedLabel:MUILabel = null;
    private missingLabel:MUILabel = null;

    awakeFromHTML(){
        this.titleLabel = MUIOutlet(this, "title-lbl", "MUILabel");
        this.totalLabel = MUIOutlet(this, "total-lbl", "MUILabel");
        this.statusView = MUIOutlet(this, "status-view", "MUIView");
        this.uncategorizedLabel = MUIOutlet(this, "uncategorized-lbl", "MUILabel");
        this.missingLabel = MUIOutlet(this, "missing-lbl", "MUILabel");
    }

    // The pending counts come from the bank's balance view row, fetched with the bank
    setItem(item:Bank, balance:number){
        let cf = (MUIWebApplication.sharedInstance().delegate as AppDelegate).currencyFormatter;

        this.titleLabel.text = item.name;
        this.totalLabel.text = cf.stringFromNumber(balance);

        let uncategorized = item.movementBalance?.uncategorizedCount ?? 0;
        let missing = item.movementBalance?.missingDocumentsCount ?? 0;
        this.uncategorizedLabel.text = uncategorized.toString();
        this.missingLabel.text = missing.toString();
        this.uncategorizedLabel.hidden = uncategorized == 0;
        this.missingLabel.hidden = missing == 0;
        this.statusView.hidden = uncategorized == 0 && missing == 0;
    }
}
